import { render, staticRenderFns } from "./LandTypeDetails.vue?vue&type=template&id=754be538&scoped=true&"
import script from "./LandTypeDetails.vue?vue&type=script&lang=js&"
export * from "./LandTypeDetails.vue?vue&type=script&lang=js&"
import style0 from "./LandTypeDetails.vue?vue&type=style&index=0&id=754be538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754be538",
  null
  
)

export default component.exports